import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Tenders } from "../api/agent";
import { useTranslation } from "react-i18next";
import parse from 'html-react-parser';

const TenderDetails = () => {
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const attachmentFiles = data.attachment || [];

  let { id } = useParams();


  const tableStyle = {
    width:"100%",
    padding: "20px", // Adjust the padding value as needed
    borderCollapse: "collapse", // Optional: For better spacing
  };

  


  useEffect(() => {
    Tenders.getById(id).then((data) => {
      // console.log(data);
      setData(data);
    });
  }, [id]);

  return (
    <div>
      {/*====================  breadcrumb area ====================*/}
      <div
        className="breadcrumb-area breadcrumb-bg"
        style={{
          backgroundImage: `url(/assets/img/backgrounds/project-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="page-banner text-center">
                <h1>{t("tender_details")}</h1>
                <ul className="page-breadcrumb">
                  <li>
                    <Link to="/">{t("home")}</Link>
                  </li>
                  <li>
                    <Link to="/tender">{t("tenders")}</Link>
                  </li>
                  <li>{t("tender_details")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*====================  End of breadcrumb area  ====================*/}

      <div className="page-wrapper section-space--inner--60">
        <div className="project-section">
          <div className="container">
            <div className="row">
              <div className="col-12 section-space--bottom--40">
                <div className="text-center">
                  <h2 dir="auto">{data.title}</h2>
                </div>
              </div>
              <div className="project-information row rounded-4 report-details">
                <div className="col-md-12 col-12 section-space--bottom--30">
                <table style={tableStyle} className="table table-striped">
  <tbody>
    <tr>
      <td>
        <strong>{t("Refno")} </strong>
      </td>
      <td>
        <strong dir="auto">{data.refno} </strong>
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("title")} </strong>
      </td>
      <td>
        <strong dir="auto">{data.title} </strong>
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("Category")} </strong>
      </td>
      <td>
        <strong>{data.catagory} </strong>
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("publish_date")} </strong>
      </td>
      <td>
        <strong>{ new Date(data.publish_date).toLocaleDateString()}</strong>
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("submission_date")} </strong>
      </td>
      <td>
        {/* <strong>{new Date(data.submission_date).toLocaleString()}</strong> */}
        <strong>{new Date(data.submission_date).toLocaleDateString()}</strong>
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("contact_person_name")} </strong>
      </td>
      <td>
        <strong>{data.contact_person_name} </strong>
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("contact_person_phone")} </strong>
      </td>
      <td>
        <strong>{data.contact_person_phone} </strong>
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("contact_person_email")} </strong>
      </td>
      <td>
        <strong>{data.contact_person_email} </strong>
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("donor")} </strong>
      </td>
      <td>
        <strong>{data.donor} </strong>
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("location")} </strong>
      </td>
      <td>
        <strong>{data.location} </strong>
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("type")} </strong>
      </td>
      <td>
        <strong>{data.type} </strong>
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("attachments")} </strong>
      </td>
      <td>
        {attachmentFiles.map((attachment, index) => (
          <a key={index} href={`${process.env.REACT_APP_SERVER}/files/tenders/${attachment.file}`} download>
            {attachment.file} &nbsp;&nbsp;&nbsp;
          </a>
        ))}
      </td>
    </tr>
    <tr>
      <td>
        <strong>{t("description")} </strong>
      </td>
      <td>
        {data.description && parse(data.description)}
      </td>
    </tr>
  </tbody>
                </table>


                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenderDetails;
